import * as React from "react";
// import { debounce } from "debounce"

import "./styles.css";
import { connect } from 'react-redux';
import { reportChangeFilterAction } from 'src/actions';
import { IRootState } from 'src/reducers';
import { IReportFilters, TimePeriod } from 'src/contracts/IReportFilters';
import { debounce } from 'debounce';

interface ISearchBoxProps {
    searchString?: string | undefined;
    onSearch: (filters: IReportFilters) => void;
}

interface ISearchBoxState {
    searchString?: string | undefined;
}

class SearchTextBox extends React.Component<ISearchBoxProps, ISearchBoxState>  {
    public state = {
        searchString: ''
    }

    private performSearch = debounce((str: string) => {
        this.props.onSearch({ startDate: undefined, endDate: undefined, timePeriod: TimePeriod.AllTime, searchString: str })
    }, 500)

    
    constructor(props: ISearchBoxProps) {
        super(props)
    }
    
    
    public render() {
        return (
            <div className="search">
                <form >
                    <label>
                        <input 
                            value={this.state.searchString} 
                            onChange={this.handleInputChange} 
                            placeholder="Search" />
                    </label>
                </form>
            </div>
        );
    }

    private handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchString: e.target.value })
        this.performSearch(e.target.value);
    }
}

export default connect(
    (state: IRootState) => ({ searchString: state.reports.filters!.searchString }), 
    { onSearch: reportChangeFilterAction }
)(SearchTextBox);



// WEBPACK FOOTER //
// ./src/components/search-text-box/index.tsx